<div class="container" [ngStyle]="{'width.px': 100 * (states.length - 2)}">
  <ul class="progressbar">
    <ng-container *ngFor="let state of states; let index = index; let first = first; let last = last;">
      <li [ngStyle]="{'width.%': 100 / (states.length - 2)}" [class]="progress === index ? 'active' : progress > index ? 'done' : ''" *ngIf="!first && !last"><span class="small-grey">{{state.name}}</span></li>
    </ng-container>
  </ul>
</div>
